export const isProduction = process.env.REACT_APP_STAGE === 'prod'

// this means the backend env is dev, but its deployed on amplify so not local
export const isAmplifyDevEnv = process.env.REACT_APP_STAGE === 'dev' && process.env.REACT_APP_IS_AMPLIFY_ENV
